var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full flex-col"},[_c('pricing'),_c('feature-sheet'),_c('features'),_c('partner-feedback')],1)}
var staticRenderFns = []

export { render, staticRenderFns }